import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import html2canvas from 'html2canvas';
import { SessionStorageService } from 'ngx-webstorage';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { Environment } from 'src/app/core/environment/environment';
import { HomeService } from 'src/app/modules/home/home.service';
import { EntityConfirmationFormComponent } from '../entity-confirmation-form/entity-confirmation-form.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToastService } from 'src/app/shared/utils/toast.service';


 (<any>pdfMake).addVirtualFileSystem(pdfFonts);

@Component({
    selector: 'entity-verification-pdf',
    templateUrl: './entity-verification-pdf.component.html',
    styleUrls: ['./entity-verification-pdf.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class EntityVerificationPdfComponent implements OnChanges   {

  @Input() entityFormData: any;
  @Input() pdfType:string;
   formData:any = null;
   emailIDs:any=[];
   loggedInUserEmailId:string
   loggedInUserName:string


   constructor(private storage: SessionStorageService,
    private homeService:HomeService,
    public dialogRef: MatDialogRef<any>, public dialog: MatDialog,
    private toasterService: ToastService,) {
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes['entityFormData'] && changes['entityFormData'].currentValue) {
        this.init();
      }
    }

    init(){
      if(this.entityFormData != null){
        this.formData = JSON.parse(JSON.stringify(this.entityFormData));
      }

      this.loggedInUserName = this.storage.retrieve(
        CacheConstant.SessionStorageData.LoggedInUser
      );
      this.loggedInUserEmailId = this.storage.retrieve(
        CacheConstant.SessionStorageData.Email
      );

    }

  async generatePdf(dialogRef) {
     const element = document.getElementById('pdf-generate');
     const canvas = await this.renderPdfCanvas(element);
     const imgData = canvas.toDataURL('image/png');
     const footerText = "© 2024 Cardinal Health. All Rights Reserved. CARDINAL HEALTH and the Cardinal Health LOGO are trademarks of Cardinal Health and may be registered in the US and/or in other countries. All other marks are the property of their respective owners."
     const documentDefinition = {
       content: [{
        image: imgData,
        width:575
       }],
       pageMargins: [10,30,15,50],
       footer: {
        columns: [
          { text: footerText, alignment: 'left',margin: [32,0,50,0], fontSize: 8,color:'#777373' }
        ]
      },
     };
     let emails=[];
     if(this.formData){
      emails.push(this.formData.hospital340BAdministratorEmail);
      emails.push(Environment.getInstance().appConfig.nuctrac340BEmailInquires);
      emails.push(this.loggedInUserEmailId);
     }


    if(this.pdfType == 'print') {
      pdfMake.createPdf(documentDefinition).open();
    }
    else {

      if(dialogRef){
        dialogRef.close();
       }

      pdfMake.createPdf(documentDefinition).getBase64(function(base64) {

        let emailPayloadRequest = {
          emailAddress:  this.formData.additionalEmails ? this.formData.additionalEmails : emails,
          shipToNum:this.formData.customerShipToNum,
          submitterId:this.loggedInUserEmailId,
          submitterName:this.loggedInUserName,
          base64:base64
        };
        this.send340BEmail(emailPayloadRequest)
      }.bind(this))
    }

  }

  renderPdfCanvas(element) {
    return html2canvas(element);
  }

  send340BEmail(emailPayloadRequest){
    this.homeService.send340BPDFEmail(emailPayloadRequest).subscribe((res: any) => {
      if (!res.hasError &&  this.formData.additionalEmails == undefined) {
        this.openConfimationForm();
      }
      else if(!res.hasError &&  this.formData.additionalEmails != undefined){
        this.toasterService.success("Email sent successfully");
      }
    });
  }

  openConfimationForm() {
    this.dialogRef = this.dialog.open(EntityConfirmationFormComponent,{
      width: '1000px',
      disableClose: true
    });
  }
}
